module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-233.fcb73b76.svg";